import { createGenericContext } from "../../../utils/createGenericContext";
export const [SelectedTicketsContext, useSelectedTicketsContext] = createGenericContext([]);
